$("[data-customCarouselPDP]").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    draggable: true,
    mobileFirst: true,
    
    responsive: [
        {
            breakpoint: 769,
            settings: {
                arrows: true,
                prevArrow: '<button type="button" class="slick-prev fa fa-chevron-left"><span class="sr-only">Previous</span></button>',
                nextArrow: '<button type="button" class="slick-next fa fa-chevron-right"><span class="sr-only">Next</span></button>',
            }
        }
    ]
});


var slidesToShowNavigator = $("[data-customPDPNavigator]").data('grid-rows');

$("[data-customPDPNavigator]").slick({
    slidesToShow: 2.5,
    slidesToScroll: 1,
    asNavFor: "[data-customCarouselPDP]",
    focusOnSelect: true,
    arrows: true,
    draggable: false,
    dots: true,
    prevArrow: '<button type="button" class="slick-prev fa fa-chevron-left"><span class="sr-only">Previous</span></button>',
    nextArrow: '<button type="button" class="slick-next fa fa-chevron-right"><span class="sr-only">Next</span></button>',
    mobileFirst: true,
    infinite: false,
    centerMode: false,

    responsive: [
        {
            breakpoint: 769,
            settings: {
                slidesToShow: parseInt(slidesToShowNavigator),
                arrows: false,
                draggable: false,
                dots: false,
                focusOnSelect: false,
                swipe: false,
                infinite: false,
            }
        }
    ]
});


$("[data-customCarouselModalCristales]").slick({
    slidesToShow: 1,
    dots: true,
    infinite: true,
    arrows: false
});

$("[data-carouselhome]").slick({
    arrows: true,
    autoplay: false,
    autoplaySpeed: 5000,
    dots: true,
    infinite: true,
    slidesToScroll: 2,
    slidesToShow: 2,
    selector: ".carousel-item",

    prevArrow:
        '<button type="button" data-role="none" class="slick-prev">Previous</button>',
    nextArrow:
        '<button type="button" data-role="none" class="slick-next">Next</button>',

    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
            },
        },
    ],
});

$('.pdp-carousel').slick({
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    dots: true,
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 1
});

$('.d-pup-carousel').slick({
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,
    dots: true,
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 1
});


$(function() {
    if($('[data-related-carousel]').length>0) {
        $('[data-related-carousel]').swipe( {
            swipe:function(event, direction, distance, duration, fingerCount, fingerData) {},
            threshold: 0,
            fingers: 'all'
        });
    }
});

$(window).on("load", function () {
    $("[data-carouselhome]").not(".slick-initialized").slick();
});

// $('[data-customCarouselModalCristalesNavigator]').slick({
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     centerMode: false,
//     focusOnSelect: true,
//     dots: true,
//     asNavFor: '[data-customCarouselModalCristales]'
// });


$(document).on('einsteincarousel:load', function () {
    $(document).find('.recommended-products.einstein-recommender').not('slick-initialized').each(function (idx, elem) {
        const contentId = $(elem).data('contentId');
        $(elem).addClass('slick-initialized');

        let slidesToShow = ($('.' + contentId + ' #carouselControls-relatedProducts-desktop .product').length < 3)
                            ? $('.' + contentId + ' #carouselControls-relatedProducts-desktop .product').length
                            : 3;

        if (slidesToShow != 0) {
            $("." + contentId + " #carouselControls-relatedProducts-desktop").slick({
                arrows: true,
                autoplay: false,
                autoplaySpeed: 5000,
                dots: true,
                infinite: true,
                slidesToScroll: 3,
                slidesToShow: slidesToShow,
                selector: '.product',
                prevArrow: '<button type="button" data-role="none" class="slick-prev">Previous</button>',
                nextArrow: '<button type="button" data-role="none" class="slick-next">Next</button>'
            });
        }
    });
});
